<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="disease-list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="buttons"
            :searchLocal="false"
            :addButton="{ permission: 'dic_disease:create' }"
            :deleteButton="{ enabled: false, permission: 'dic_disease:delete' }"
            :updateButton="{ enabled: false, permission: 'dic_disease:update' }"
            @relationDesease="relationDesease"
        >
        </crud-facecade>
        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="refreshList"
            @current-change="refreshList"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
        <relation :title="relation.title" :visible.sync="relation.visible" :item="relation.item" area="Disease" @after-relation="reloadListData"></relation>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import relation from '../Relation'
export default {
    name: `DictionaryDisease`,
    components: { relation },
    props: {

    },
    data() {
        return {
            title: `基础数据-诊断`,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            url: {
                baseURL: `/api/AcisSystem/Disease`,
                // get: `/api/AcisSystem/Disease/GetPage`
                get: q => {
                    let that = this
                    let clientIp = sessionStorage.getItem(`clientIp`)
                    if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                        clientIp = ``
                    }
                    let token = sessionStorage.getItem(`token`)
                    let authorization = `bearer ${token}`
                    if (!token || token === `undefined` || token === `null`) {
                        authorization = undefined
                    }
                    q.page = that.currentPage
                    q.pageSize = that.pageSize
                    return new Promise(resolve => {
                        let req = that.axios.post(`/api/AcisSystem/Disease/GetPageNew`, q
                            , {
                                headers: {
                                    'Authorization': authorization,
                                    'clientIp': clientIp
                                },
                                emulateJSON: true
                            }, false)
                        req.then(res => {
                            this.total = res.count
                            var data = res.data
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                            resolve([])
                        })
                    })
                }
            },
            buttons: [],
            relation: {
                title: ``,
                visible: false,
                item: {}
            }
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `code`,
                label: this.T(`disease.code`),
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: function(that, { row, column, area }) {
                    if (area == `form`) {
                        return row.enum_dic_type === 2
                    } else if (area == `itemgroup`) {
                        return false
                    } else {
                        return true
                    }
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                // sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `140`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                searchable: false,
                isCreatable: false,
                sortable: true
            }, {
                type: `select`,
                prop: `enum_dic_type`,
                label: `属性`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                options: function(that, { area }) {
                    if (area == `list` || area == `query`) {
                        return [{ value: 1, label: `院内版` }, { value: 2, label: `非标准` }, { value: 3, label: `互联互通` }, { value: 4, label: `上传` }, { value: 5, label: `国标` }]
                    }
                    return [{ value: 1, label: `院内版` }, { value: 2, label: `非标准` }]
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                change: function(that, { row, column }) {
                    if (row.enum_dic_type === 2) {
                        row.code = `  `
                        row._code_disabled = true
                    }
                }
            }, {
                type: `string`,
                prop: `relation_text`,
                label: `关联诊断`,
                // width: "240",
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                sortable: false
            }, {
                type: `string`,
                prop: `creator`,
                label: `操作人`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: false
            }, {
                type: `datetime`,
                prop: `create_date`,
                label: `操作时间`,
                width: `140`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: false
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `140`,
                fixed: `right`,
                config: {
                    align: `flex-start`
                },
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                sortable: false,
                readonly: false,
                options: function(that, { row }) {
                    if (row.enum_dic_type >= 3) {
                        return [{
                            class: `is-plain`,
                            label: `关联诊断`,
                            icon: ``,
                            type: `primary`,
                            emit: `relationDesease`,
                            permission: `dic_disease:relation`
                        }]
                    } else {
                        return [{
                            class: `is-plain`,
                            label: `关联诊断`,
                            icon: ``,
                            type: `primary`,
                            emit: `relationDesease`,
                            permission: `dic_disease:relation`
                        }, {
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `dic_disease:update`
                        }]
                    }
                }

            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        refreshList() {
            this.$refs[`disease-list`].ReloadListData()
        },
        relationDesease({ index, row }) {
            this.relation.title = `关联诊断`
            // console.log(row)
            this.$set(this.relation, `item`, { ...row })
            this.relation.visible = true
        },
        reloadListData() {
            this.$refs[`disease-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Disease/Index.vue